// Messages between the main thread (EngineHost) and the audio worklet (worklet.ts).
import type { RingBuffers } from "./ring";

export type ToWorklet =
  | { type: "init"; wasm: ArrayBuffer; rings: { cmd: RingBuffers; events: RingBuffers } | null }
  | { type: "sample"; id: string; bytes: ArrayBuffer }
  | { type: "editor"; period: string; loop: string; arrangement: string; neighbour: string }
  | { type: "project"; json: string }
  | { type: "transport"; action: "play" | "stop" | "record" }
  | { type: "recording"; on: boolean }
  | { type: "period"; json: string }
  | { type: "loop"; day: number; slot: number; json: string; gain: number }
  | { type: "locate"; bar: number; sample: number; bpm: number }
  | { type: "nudge"; samples: number }
  | { type: "world-stop" }
  | { type: "latency"; samples: number }
  // Realtime commands when no SharedArrayBuffer ring is available:
  | { type: "cmd"; rec: number[] };

export type FromWorklet =
  | { type: "ready"; frameOffset: number; sampleRate: number; isolated: boolean }
  | { type: "ack"; id: number }
  | { type: "error"; message: string; context: string }
  | { type: "events"; data: Float64Array; count: number };

/** Event record layout: see `engine-wasm` `drain_events`. */
export const EVENT_STRIDE = 40;
export const enum Ev {
  Clock = 1,
  PadHit = 2,
  PadRelease = 3,
  Recorded = 4,
  RecordedRelease = 5,
  Meters = 6,
}
